import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { connect, ConnectedProps } from 'react-redux';
import { restrictToEnterprise, search } from '../../../../state/actions';
import { StateType } from '../../../../../state/state.types';

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  onRestrictToEnterprise(
    data: {
      enterpriseId: string;
      raisonSociale: string;
    } & (
      | { readonly type: 'ville'; ville: string | null }
      | { readonly type: 'juridiction'; juridiction: string | null }
      | { readonly type: 'year'; year: string }
    ),
  ) {
    dispatch(restrictToEnterprise(data));
    dispatch(search({ reason: 'restrict-from-snippet' }));
  },
});

export const Connect = connect(null, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
